<template>
  <div>
    <div class="class-desktop">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            href="#linkedPayerRead"
            role="tab"
            data-toggle="tab"
            >Pagadores vinculados</a
          >
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content" style="margin-top: 30px">
        <div role="tabpanel" class="tab-pane active" id="linkedPayerRead">
          <div class="table-wrapper-scroll-y my-custom-scrollbar">
            <table class="table table-sm table-striped">
              <thead>
                <tr style="font-size: 12px">
                  <th></th>
                  <th>Vincular</th>
                  <th>Inscrição pagador</th>
                  <th>Pagador</th>
                  <th>Inscrição beneficiário</th>
                  <th>Beneficiário</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="payer in linkedsPayer"
                  :key="'linkPay' + payer.sac_id"
                >
                  <th scope="row"></th>

                  <td class="align-middle">
                    <label class="switch">
                      <input
                        id="sliderLinkedUserRead"
                        v-on:click="linkPayer(payer, $event)"
                        type="checkbox"
                        class="success"
                        checked
                        disabled
                      />
                      <span class="slider"></span>
                    </label>
                  </td>

                  <td class="align-middle">
                    {{ payer.sac_inscricao | formatCPFCNPJ }}
                  </td>
                  <td class="align-middle">
                    {{ payer.sac_razao_social_nome }}
                  </td>
                  <td class="align-middle">
                    {{ payer.ced_inscricao | formatCPFCNPJ }}
                  </td>
                  <td class="align-middle">
                    {{ payer.ced_razao_social_nome }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="display: flex; justify-content: flex-end">
            <p
              style="color: rgb(100, 95, 95); font-size: 13px; margin-top: 10px"
            >
              Total de vinculados: {{ this.linkedsPayer.length }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- MOBILE SCREEN -->
    <!-- form filters of registered users mobile screen -->
    <div class="row justify-content-center class-mobile">
      <div class="col-md-12">
        <div class="nav btn-group">
          <a href="#linkedRead" class="btn btn-tab" data-toggle="tab">
            Pagadores vinculados
          </a>
        </div>
        <div class="tab-pane" id="linkedRead">
          <div style="height: 300px; overflow-y: scroll">
            <div
              v-for="payer in linkedsPayer"
              :key="'linkPay' + payer.sac_id"
              class="principal-div"
            >
              <div class="col col-divs">
                <div style="width: 25%">
                  <label class="switch">
                    <input
                      id="sliderLinkedUserReadMobile"
                      v-on:click="linkPayer(payer, $event)"
                      type="checkbox"
                      class="success"
                      checked
                      disabled
                    />
                    <span class="slider"></span>
                  </label>
                </div>
                <div style="width: 70%">
                  <label>Pagador</label><br />
                  {{ payer.sac_inscricao | formatCPFCNPJ }}
                  {{ payer.sac_razao_social_nome }}
                </div>

                <button
                  id="collapseReadLink"
                  style="
                    width: 15%;
                    background-color: transparent;
                    border: none;
                  "
                  class="accordion-toggle"
                  data-toggle="collapse"
                  :data-target="'#mobile' + payer.sac_id"
                >
                  <em class="fa fa-chevron-down icons icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div
                  class="accordian-body collapse"
                  :id="'mobile' + payer.sac_id"
                >
                  <div class="col col-divs">
                    <div style="width: 100%">
                      <label>Beneficiário</label><br />
                      {{ payer.ced_inscricao | formatCPFCNPJ }}
                      {{ payer.ced_razao_social_nome }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: flex-end">
            <p
              style="
                color: rgb(100, 95, 95);
                font-size: 14px;
                margin-top: 10px;
                margin-right: 10px;
              "
            >
              Total de vinculados: {{ this.linkedsPayer.length }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Pagination from "../../../../common/components/Pagination";
import moment from "moment";

export default {
  name: "ReadLinkUser",
  components: {
    Pagination,
  },
  data() {
    return {
      payers: [],
      linkedsPayer: [],
      filters: {},
      filterSearch: "",
      filterText: "",
    };
  },

  props: ["userId"],

  methods: {
    getPayers: function () {
      axios
        .get(`${process.env.API_PBM}/payers/linkedPayers/${this.userId}`)
        .then((linkedPayers) => {
          if (linkedPayers.data.data.payers) {
            this.linkedsPayer = linkedPayers.data.data.payers;
          }
        })
        .catch((error) => {
          Vue.$toast.error("Ops! Não foi possível buscar os dados.", {
            position: "top-right",
            duration: 5000,
          });
        });
      axios
        .get(`${process.env.API_PBM}/payers/unlinkedPayers/${this.userId}`, {
          params: this.filters,
        })
        .then((unlinkedPayers) => {
          if (unlinkedPayers.data.data.payers) {
            this.payers = unlinkedPayers.data.data.payers;
          } else {
            this.payers = [];
          }
        })
        .catch((error) => {
          Vue.$toast.error("Ops! Não foi possível buscar os dados.", {
            position: "top-right",
            duration: 5000,
          });
        });
    },

    setFilter: function (filter, value, reset = false) {
      if (reset) {
        this.filters = {};
      }
      this.filters[filter] = value;
      this.getPayers();
    },

    clearFilterText: function () {
      this.filterText = "";
      if (this.filterSearch === "selecione") {
        this.filters = {};
        this.getPayers();
      }
    },

    linkPayer: function (payerArray, event) {
      if (event.target.checked) {
        this.linkedsPayer.push(payerArray);
        let index = this.payers.indexOf(payerArray);

        if (index !== -1) {
          this.payers.splice(index, 1);
        }
      } else {
        this.payers.push(payerArray);
        let index = this.linkedsPayer.indexOf(payerArray);
        if (index !== -1) {
          this.linkedsPayer.splice(index, 1);
        }
      }
    },

    sendLinkedPayers: function () {
      let idPayers = this.linkedsPayer.map((payer) => {
        return payer.sac_id;
      });
      this.$emit("stepEditLinkedPayer", idPayers);
    },
  },

  mounted() {
    this.getPayers();

    this.filterSearch = "selecione";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-filter {
  margin-top: 5px;
  margin-bottom: 5px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
a {
  text-decoration: none;
  color: #424242;
}

.selectpicker {
  height: 30px;
  font-size: 13px;
  color: rgb(100, 95, 95);
  width: 32%;
  margin-top: 2px;
  margin-right: 10px;
}

.access-filter {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 0px;
  font-size: 15px;
  height: 30px;
  width: 20%;
  margin-left: 10px;
}

.text-join {
  color: rgb(100, 95, 95);
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: -5px;
}

.table-sm td,
.table-sm th {
  padding: 0px;
  padding-left: 10px;
}
table thead th {
  background-color: #cacaca;
  color: #424242;
  font-size: 14px;
  text-align: center;

  position: sticky;
  top: 0;
}
table thead {
  background-color: #cacaca;
  color: rgb(100, 95, 95);
  z-index: 2;
  position: inherit;
}
.table {
  position: relative;
}

.my-custom-scrollbar {
  position: relative;
  height: 170px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}

table tr {
  white-space: nowrap;
}
tbody {
  font-size: 12px;
  color: rgb(100, 95, 95);
}
.access {
  color: #fff;
  width: 20%;
  margin-top: 5px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-bottom: -20px;
}
.access-center {
  text-align: center;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 26px;
  float: left;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  top: 12px;
  left: 16px;
  right: 9px;
  bottom: 5px;
  border-radius: 12px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 13px;
  left: -8px;
  bottom: -1px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 17px;
  box-shadow: 1px 1px 1px;
}

input.success:checked + .slider {
  background-color: #58970f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
@media only screen and (max-width: 900px) {
  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }
  .form-control:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }

  .col-md-12 {
    background: #ebe7e7;
    padding: 3%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .access {
    color: #fff;
    border-radius: 6px;
    width: 45%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }
  .btn-group {
    display: flex;
    justify-content: center;
  }

  .btn-filter {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 13px;
  }

  .hiddenRow {
    padding: 0 !important;
  }

  label {
    display: inline-block;
    font-size: 13px;
    color: #424242;
  }

  .icons {
    font-size: 20px;
    cursor: pointer;
  }

  .col-divs {
    display: inline-flex;
    margin: 0 auto;
    font-size: 11px;
  }
  .btn-tab {
    font-size: 12px;
  }
  .principal-div {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 6px;
    padding: 5px;
    color: rgb(100, 95, 95);
  }
  .access-filter {
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    height: 33px;
    width: 20%;
  }
  .access-mobile {
    color: #fff;
    border-radius: 6px;
    width: 100%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .form-group input,
  textarea {
    background-color: #fff;
    margin-bottom: 10px;
    margin-top: 3px;
    line-height: 1rem;
    font-size: 15px;
    margin-left: 0px;
    width: 100%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 49px;
    height: 26px;
    float: left;
  }

  /* Hide default HTML checkbox */
  .switch input {
    display: none;
  }

  /* The slider */
  .slider {
    position: absolute;
    top: 28px;
    left: 9px;
    right: 9px;
    bottom: -12px;
    border-radius: 12px;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 13px;
    left: -8px;
    bottom: -1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 17px;
    box-shadow: 1px 1px 1px;
  }

  input.success:checked + .slider {
    background-color: #58970f;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .selectpicker {
    width: 35%;
  }
  .active {
    background-color: #ebe7e7 !important;
    color: #424242;
  }
}

.class-mobile {
  display: none;
}

.active {
  background: #fff;
  color: #424242;
}
</style>



// WEBPACK FOOTER //
// src/views/components/user/read/ReadLinkUser.vue